import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"


import { onMounted, ref } from 'vue'
import DetailCard from '@/components/DetailCard'
import { customerPhaseEnum, arkCodeStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { queryCosArkCodeDeatil } from '@/api/gucangSales/customerCenter'
import { useRoute, useRouter } from 'vue-router'
import { CustomerCode } from '@/typings/api/customerCenter'
const __default__ = { name: 'TabsCode' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const router = useRouter()
const detail = ref([])

const fetch = () => {
  queryCosArkCodeDeatil({
    cosId: route.query.cosId
  }).then((res) => {
    detail.value = res.data
  })
}
onMounted(() => {
  fetch()
})
const columns = ref([
  { title: '子客户代码', dataIndex: 'arkCode' },
  {
    title: '客户阶段',
    dataIndex: 'stage',
    node: 'cos-select',
    attrs: {
      options: customerPhaseEnum
    }
  },
  { title: '子客户代码名称', dataIndex: 'arkAccount' },
  { title: '档次', dataIndex: 'level' },
  { title: '联系人', dataIndex: 'arkContactName' },
  { title: '成交金额（万）', dataIndex: 'amount' },
  { title: '手机号', dataIndex: 'arkContactMobile' },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '客户负责人', dataIndex: 'sellerName' },
  { title: '创建时间', dataIndex: 'createTime' },
  {
    title: 'ark账号状态',
    dataIndex: 'status',
    node: 'cos-select',
    attrs: {
      options: arkCodeStatusEnum
    }
  },
  {
    title: '主体数量',
    dataIndex: 'subjectCount'
  }
])
// 跳转到签约主体列表
const linkToMainBody = (row: CustomerCode) => {
  if (!row.subjectCount) {
    return
  }
  router.push({
    path: '/fbu/mainBody',
    query: {
      customerCode: row.arkCode
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_dc_layout_empty = _resolveComponent("dc-layout-empty")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      ref: "formRef",
      name: "advanced_search"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(DetailCard), {
            columns: columns.value,
            key: index,
            title: `客户代码信息${index + 1}`,
            data: item
          }, {
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'subjectCount')
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (linkToMainBody(record))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(text || 0), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["columns", "title", "data"]))
        }), 128)),
        (!detail.value || !detail.value.length)
          ? (_openBlock(), _createBlock(_component_dc_layout_empty, {
              key: 0,
              type: "nothing"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_cos_footer_button, { hideOk: true })
  ], 64))
}
}

})